import type { StrapiSliderBlock } from "../types";

interface SliderBlockProps {
  block: StrapiSliderBlock;
}

export const SliderBlock = ({ block }: SliderBlockProps) => {
  return (
    <div className="flex gap-4 overflow-auto py-2">
      {block.files.map((file, fileIndex) => (
        <img
          key={fileIndex}
          src={file.url}
          alt={file.alternativeText || ""}
          className="h-75 w-auto rounded-lg shrink-0"
        />
      ))}
    </div>
  );
};
